// extracted by mini-css-extract-plugin
export default {"display":"Wrapper_display__mrvxG","wrapper":"Wrapper_wrapper__PZ9aK","appArea":"Wrapper_appArea__pOIZW"};